module.exports = __webpack_public_path__ + "img/user.439b688e.svg";